<template>
  <div>
    <a-table
      bordered
      size="small"
      id="tbl_budget"
      :columns="kolom"
      :data-source="data"
      :pagination="false"
      :indentSize="10"
      @expand="onExpand"
      checkable
      :expanded-keys="expandedKeys"
      :auto-expand-parent="autoExpandParent"
      :scroll="{ x: longwidthTable, y: 450 }"
      :defaultExpandedRowKeys="defaultexpandedKeys"
      :defaultExpandAllRows="true"
      :headerTitle="headerTitleData"
      :loading="loadingtable"
    >
      <div slot="title">

        <!-- <tr >
            <td colspan="1" style="font-weight: bold;border: 0px !important;">BUDGET TYPE&nbsp;</td>
            <td colspan="1" style="border: 0px !important;">({{headerTitleData[0].jns_anggaran_id}}) {{headerTitleData[0].jenis_anggaran}}</td>
        </tr> -->

        <div style="display: flex; width: 100%; justify-content: space-between; align-items: center;">
          <div style="display: flex; flex-direction: row;">
            <span style="font-weight: bold;">BUDGET TYPE&nbsp;</span>
            <span>({{headerTitleData[0].jns_anggaran_id}}) {{headerTitleData[0].jenis_anggaran}}</span>
          </div>
          <div>
            <slot name="button-extra"></slot>
          </div>
        </div>

        <tr v-if="headerTitleData[0].available">
          <td style="font-weight: bold;border: 0px !important;">COST CENTER CODE</td>
          <td style="border: 0px !important;">{{headerTitleData[0].kode_cost_center}}</td>
        </tr>

        <tr v-if="headerTitleData[0].available">
          <td style="font-weight: bold;border: 0px !important;">JOB NAME</td>
          <td style="border: 0px !important;">{{headerTitleData[0].nama_pekerjaan}}</td>
        </tr>

        <tr v-if="headerTitleData[0].available">
          <td style="font-weight: bold;border: 0px !important;">COMPILER</td>
          <td style="border: 0px !important;">{{headerTitleData[0].penyusun_anggaran}}</td>
        </tr>

        <tr v-if="headerTitleData[0].available">
          <td style="font-weight: bold;border: 0px !important;">BUDGET GA AUTHORITY</td>
          <td style="border: 0px !important;">{{headerTitleData[0].kuasa_anggaran_ga ? headerTitleData[0].kuasa_anggaran_ga:'-'}}</td>
        </tr>

        <tr v-if="headerTitleData[0].available">
          <td style="font-weight: bold;border: 0px !important;">BUDGET MARKETING/IBD</td>
          <td style="border: 0px !important;">{{headerTitleData[0].kuasa_anggaran_marketing ? headerTitleData[0].kuasa_anggaran_marketing: '-'}}</td>
        </tr>

        <tr v-if="headerTitleData[0].available">
          <td style="font-weight: bold;border: 0px !important;">BUDGET OPERATION AUTHORITY</td>
          <td style="border: 0px !important;">{{headerTitleData[0].kuasa_anggaran_operasi ? headerTitleData[0].kuasa_anggaran_operasi:'-'}}</td>
        </tr>

        <tr v-if="headerTitleData[0].available">
          <td style="font-weight: bold;border: 0px !important;">FISCAL YEAR</td>
          <td style="border: 0px !important;" >{{headerTitleData[0].tahun_anggaran}}</td>
        </tr>

        <tr v-if="headerTitleData[0].available">
          <td style="font-weight: bold;border: 0px !important;">REVISION NUMBER</td>
          <td style="border: 0px !important;">{{headerTitleData[0].revisi_ke ? headerTitleData[0].revisi_ke : '-'}}</td>
        </tr>

      </div>
      <span slot="customTitleMain" style="vertical-align: middle">
        <b>BUDGETING</b>
        &nbsp;
        <a-popover
          slot="extra"
          :visible="visible"
          placement="rightTop"
          trigger="click"
        >
          <div slot="title">
            <span>Detil Anggaran</span>
            <a @click="hide" style="float: right"><a-icon type="close" /></a>
          </div>
          <div slot="content">
            <a-form :form="formadd">
              <a-form-item label="Peruntukan">
                <a-select
                  showSearch
                  allowClear
                  option-filter-prop="children"
                  :filter-option="filterOptionperuntukan"
                  @change="handleperuntukan"
                  v-decorator="['peruntukan', { rules: [{ required: true }] }]"
                >
                  <a-select-option v-for="item in datatree" :key="item.peruntukan_id">{{
                    item.nama_peruntukan
                  }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Sub Peruntukan">
                <a-auto-complete
                  class="certain-category-search"
                  dropdownClassName="certain-category-search-dropdown"
                  :dropdownMatchSelectWidth="false"
                  optionLabelProp="value"
                  v-decorator="[
                    'subperuntukan',
                    { rules: [{ required: true }] },
                  ]"
                >
                  <template slot="dataSource">
                    <a-select-option
                      v-for="item in suggestOpsiPeruntukan"
                      :key="item.sub_peruntukan"
                      :value="item.sub_peruntukan"
                      >{{ item.sub_peruntukan }}</a-select-option
                    >
                  </template>
                  <a-input>
                    <a-icon
                      slot="suffix"
                      type="search"
                      class="certain-category-icon"
                    />
                  </a-input>
                </a-auto-complete>
              </a-form-item>
              <a-form-item label="Item Anggaran">
                <a-input
                  :maxLength="15"
                  v-decorator="[
                    'item_anggaran',
                    { rules: [{ required: true }] },
                  ]"
                ></a-input>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button
                  @click="modalbuttonAdd"
                  :loading="loadingAdd"
                  block
                  type="primary"
                  html-type="submit"
                  >Tambah</a-button
                >
              </a-form-item>
            </a-form>
          </div>
          <a-button
            v-if="allowtoEdit"
            size="small"
            @click="hide"
            style="float: right; vertical-align: middle"
          >
            <a-icon type="plus" />
          </a-button>
        </a-popover>
        <a-button
          v-if="allowtoEdit"
          style="float: right"
          type="primary"
          size="small"
        >
          Import
        </a-button>
      </span>

      <span slot="customTitleAllTahun">
        <a-dropdown>
          <a-menu slot="overlay" @click="handleMenuClick">
            <a-menu-item
              v-for="lookmenu in lookupmenu"
              :key="lookmenu.key + ':' + lookmenu.label + ':' + lookmenu.root"
            >
              <template
                v-if="lookmenu.key == 'rekap' && lookmenu.label == 'hide'"
              >
                <a-icon type="left-square" />Collapse All Data Period
              </template>
              <template
                v-else-if="
                  lookmenu.key == 'rekap' && lookmenu.label == 'unhide'
                "
              >
                <a-icon type="right-square" />Expand All Data Period
              </template>
              <template v-else-if="lookmenu.label == 'unhide'">
                <a-icon type="left-square" />Collapse {{ lookmenu.key }}
              </template>
              <template v-else>
                <a-icon type="right-square" />Expand {{ lookmenu.key }}
              </template>
            </a-menu-item>
          </a-menu>
          <a-button
            style="float: left; vertical-align: middle"
            size="small"
            type="dashed"
            shape="circle"
            icon="more"
          />
        </a-dropdown>
        &nbsp;{{ toptitle }}
        <input type="hidden" v-model="HeaderisClicked" id="HeaderisClicked" />
        <a-button
          id="TopHeaderButtonClick"
          @click="hideunhideALL"
          hidden="true"
        />
      </span>
      <span slot="name" slot-scope="name" style="vertical-align: middle">
        <a-tooltip placement="top">
          <template slot="title">
            <span v-if="name.nameitem.length > 30">
            {{ name.nameitem.trim() }}{{ name.kode ? "(" + name.kode.trim() + ")" : "" }}
            </span>
          </template>
          <b v-if="name.root === true">{{ name.nameitem }}</b>

          <span v-else>
              <b v-if="name.kode">
                  {{
              name.nameitem.length > 30
                ? name.nameitem.trim().substring(0, 30) + " ..."
                : name.kode
                ? (name.nameitem.trim() + " (" + name.kode.trim() + ")")
                : name.nameitem.trim()
            }}
              </b>
              <span v-else>
                  {{ name.nameitem.length > 30
                ? name.nameitem.trim().substring(0, 30) + " ..."
                : name.kode
                ? (name.nameitem.trim() + " (" + name.kode.trim() + ")")
                : name.nameitem.trim()
            }}
              </span>

            <!-- {{ name.nameitem.trim() }}
            {{ name.kode ? "(" + name.kode.trim() + ")" : "" }} -->
          </span>

          <!-- <a-popover
            :visible="popoverEditCodeCostCenter == name.key"
            :key="name.key"
            placement="rightTop"
            trigger="click"
          >
            <a slot="title" style="float: right" @click="closePopOver()">X</a>
            <template slot="content">
              <a-form-item>
                <a-input
                  v-model="editTextCostCenter"
                  type="text"
                  @pressEnter="simpanEditCostcenter()"
                />
                <a-input
                  v-model="editCodeCostCenter"
                  style="display: none"
                  type="text"
                />
              </a-form-item>
              <a-button type="primary" @click="simpanEditCostcenter()" block>
                Save
              </a-button>
            </template> -->
            <a-button
              v-if="name.editable === true && allowtoEdit"
              @click="showPopOverEditCostcenter(name)"
              style="float: right; vertical-align: middle"
              size="small"
              type="dashed"
              shape="circle"
              icon="edit"
            />
          <!-- </a-popover> -->
        </a-tooltip>
      </span>

      <div slot="dtlitemcode" slot-scope="item">
        <a-tooltip placement="topLeft" title="Realisasi Budget">
          <a @click="handleModal(item)" style="font-size: 12px">{{ item }}</a>
        </a-tooltip>
      </div>
      <span slot="dtlitemprice" slot-scope="item">
        <span v-if="item">{{
          formatRupiah(item).replace("Rp&nbsp;", "").replace(",00", "")

        }}</span>
        <span v-else></span>
      </span>
      <span slot="dtlitem01" slot-scope="text, record">
        <editable-cell
          v-if="record.editable === true && allowtoEdit && 1==0"
          :text="text[1].toString()"
          @change="onCellChange(record.key, text[0], $event)"
        />
        <span v-else>{{
          formatRupiah(text[1]).replace("Rp&nbsp;", "").replace(",00", "")
        }}</span>
      </span>
      <span slot="dtlitem02" slot-scope="text, record">
        <editable-cell
          v-if="record.editable === true && allowtoEdit && 1==0"
          :text="text[1].toString()"
          @change="onCellChange(record.key, text[0], $event)"
        />
        <span v-else>{{
          formatRupiah(text[1]).replace("Rp&nbsp;", "").replace(",00", "")
        }}</span>
      </span>
      <span slot="dtlitem03" slot-scope="text, record">
        <editable-cell
          v-if="record.editable === true && allowtoEdit && 1==0"
          :text="text[1].toString()"
          @change="onCellChange(record.key, text[0], $event)"
        />
        <span v-else>{{
          formatRupiah(text[1]).replace("Rp&nbsp;", "").replace(",00", "")
        }}</span>
      </span>
      <span slot="dtlitem04" slot-scope="text, record">
        <editable-cell
          v-if="record.editable === true && allowtoEdit && 1==0"
          :text="text[1].toString()"
          @change="onCellChange(record.key, text[0], $event)"
        />
        <span v-else>{{
          formatRupiah(text[1]).replace("Rp&nbsp;", "").replace(",00", "")
        }}</span>
      </span>
      <span slot="dtlitem05" slot-scope="text, record">
        <editable-cell
          v-if="record.editable === true && allowtoEdit && 1==0"
          :text="text[1].toString()"
          @change="onCellChange(record.key, text[0], $event)"
        />
        <span v-else>{{
          formatRupiah(text[1]).replace("Rp&nbsp;", "").replace(",00", "")
        }}</span>
      </span>
      <span slot="dtlitem06" slot-scope="text, record">
        <editable-cell
          v-if="record.editable === true && allowtoEdit && 1==0"
          :text="text[1].toString()"
          @change="onCellChange(record.key, text[0], $event)"
        />
        <span v-else>{{
          formatRupiah(text[1]).replace("Rp&nbsp;", "").replace(",00", "")
        }}</span>
      </span>
      <span slot="dtlitem07" slot-scope="text, record">
        <editable-cell
          v-if="record.editable === true && allowtoEdit && 1==0"
          :text="text[1].toString()"
          @change="onCellChange(record.key, text[0], $event)"
        />
        <span v-else>{{
          formatRupiah(text[1]).replace("Rp&nbsp;", "").replace(",00", "")
        }}</span>
      </span>
      <span slot="dtlitem08" slot-scope="text, record">
        <editable-cell
          v-if="record.editable === true && allowtoEdit && 1==0"
          :text="text[1].toString()"
          @change="onCellChange(record.key, text[0], $event)"
        />
        <span v-else>{{
          formatRupiah(text[1]).replace("Rp&nbsp;", "").replace(",00", "")
        }}</span>
      </span>
      <span slot="dtlitem09" slot-scope="text, record">
        <editable-cell
          v-if="record.editable === true && allowtoEdit && 1==0"
          :text="text[1].toString()"
          @change="onCellChange(record.key, text[0], $event)"
        />
        <span v-else>{{
          formatRupiah(text[1]).replace("Rp&nbsp;", "").replace(",00", "")
        }}</span>
      </span>
      <span slot="dtlitem10" slot-scope="text, record">
        <editable-cell
          v-if="record.editable === true && allowtoEdit && 1==0"
          :text="text[1].toString()"
          @change="onCellChange(record.key, text[0], $event)"
        />
        <span v-else>{{
          formatRupiah(text[1]).replace("Rp&nbsp;", "").replace(",00", "")
        }}</span>
      </span>
      <span slot="dtlitem11" slot-scope="text, record">
        <editable-cell
          v-if="record.editable === true && allowtoEdit && 1==0"
          :text="text[1].toString()"
          @change="onCellChange(record.key, text[0], $event)"
        />
        <span v-else>{{
          formatRupiah(text[1]).replace("Rp&nbsp;", "").replace(",00", "")
        }}</span>
      </span>
      <span slot="dtlitem12" slot-scope="text, record">
        <editable-cell
          v-if="record.editable === true && allowtoEdit && 1==0"
          :text="text[1].toString()"
          @change="onCellChange(record.key, text[0], $event)"
        />
        <span v-else>{{
          formatRupiah(text[1]).replace("Rp&nbsp;", "").replace(",00", "")
        }}</span>
      </span>

      <span slot="dtlitemrekap" slot-scope="text">
        <span>{{
          formatRupiah(text).replace("Rp&nbsp;", "").replace(",00", "")
        }}</span>
      </span>
    </a-table>
    <div style="display: flex; width: 100%; margin-top: 1rem; justify-content: end;">
      <slot name="submit"></slot>
    </div>

    <ModalCodeBudget
      :kode="modal.item"
      :visible="modal.visible"
      :cancel="handleModal"
      :source="modal.data"
    />

    <a-modal
      v-model="modaleditvalueanggaran"
      :title="modaleditvalueanggarantitle"
      :width="1000"
      :maskClosable="false"
    >
    <a-row :gutter="8" style="background:#fafafa">
            <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
              <a-form-model-item label="Budget Name" prop="budgetname">
                <a-input v-model="formeditanggaran.model.name"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <a-form-model-item label="Realization" prop="realization">
                <a-input-number
                  :min="0"
                  class="m-width-full m-text-align-right"
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  v-model="formeditanggaran.model.realization"
                  disabled
                ></a-input-number>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="8" style="background:#fafafa">
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <a-form-model-item label="Unit" prop="unit">
                <a-input-number
                  :min="1"
                  class="m-width-full m-text-align-right"
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  v-model="formeditanggaran.model.unit"
                  ></a-input-number>
                  <!-- @change="handlechangetototalprice" -->
              </a-form-model-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <a-form-model-item label="Unit Price" prop="unit_price">
                <a-input-number
                  :min="0"
                  class="m-width-full m-text-align-right"
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  v-model="formeditanggaran.model.unit_price"
                  ></a-input-number>
                  <!-- @change="handlechangetototalprice" -->
              </a-form-model-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <a-form-model-item label="Total Price" prop="total_price">
                <a-input-number
                  :min="0"
                  disabled
                  class="m-width-full m-text-align-right"
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  v-model="formeditanggaran.model.total_price"
                ></a-input-number>
              </a-form-model-item>
            </a-col>
          </a-row>
      <a-form-model
        ref="formeditvalueanggaran"
        :model="formeditanggaran.model"
        :rules="formeditanggaran.rules"
        class="steps-content m-flex1"
      > 
          <a-row :gutter="8">
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <a-form-model-item label="January" prop="jan">
                <a-input-number
                  :min="0"
                  class="m-width-full m-text-align-right"
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  v-model="formeditanggaran.model.jan"
                  @change="handleChangeValueBulan"
                  ></a-input-number>
              </a-form-model-item>
              <a-form-model-item label="April" prop="apr">
                <a-input-number
                  :min="0"
                  class="m-width-full m-text-align-right"
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  v-model="formeditanggaran.model.apr"
                  @change="handleChangeValueBulan"
                  ></a-input-number>
              </a-form-model-item>
              <a-form-model-item label="July" prop="jul">
                <a-input-number
                  :min="0"
                  class="m-width-full m-text-align-right"
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  v-model="formeditanggaran.model.jul"
                  @change="handleChangeValueBulan"
                  ></a-input-number>
              </a-form-model-item>
              <a-form-model-item label="Oktober" prop="okt">
                <a-input-number
                  :min="0"
                  class="m-width-full m-text-align-right"
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  v-model="formeditanggaran.model.okt"
                  @change="handleChangeValueBulan"
                  ></a-input-number>
              </a-form-model-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <a-form-model-item label="February" prop="feb">
                <a-input-number
                  :min="0"
                  class="m-width-full m-text-align-right"
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  v-model="formeditanggaran.model.feb"
                  @change="handleChangeValueBulan"
                  ></a-input-number>
              </a-form-model-item>
              <a-form-model-item label="May" prop="mei">
                <a-input-number
                  :min="0"
                  class="m-width-full m-text-align-right"
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  v-model="formeditanggaran.model.mei"
                  @change="handleChangeValueBulan"
                  ></a-input-number>
              </a-form-model-item>
              <a-form-model-item label="August" prop="aug">
                <a-input-number
                  :min="0"
                  class="m-width-full m-text-align-right"
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  v-model="formeditanggaran.model.aug"
                  @change="handleChangeValueBulan"
                  ></a-input-number>
              </a-form-model-item>
              <a-form-model-item label="November" prop="nov">
                <a-input-number
                  :min="0"
                  class="m-width-full m-text-align-right"
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  v-model="formeditanggaran.model.nov"
                  @change="handleChangeValueBulan"
                  ></a-input-number>
              </a-form-model-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <a-form-model-item label="March" prop="mar">
                <a-input-number
                  :min="0"
                  class="m-width-full m-text-align-right"
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  v-model="formeditanggaran.model.mar"
                  @change="handleChangeValueBulan"
                  ></a-input-number>
              </a-form-model-item>
              <a-form-model-item label="Juny" prop="jun">
                <a-input-number
                  :min="0"
                  class="m-width-full m-text-align-right"
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  v-model="formeditanggaran.model.jun"
                  @change="handleChangeValueBulan"
                  ></a-input-number>
              </a-form-model-item>
              <a-form-model-item label="September" prop="sep">
                <a-input-number
                  :min="0"
                  class="m-width-full m-text-align-right"
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  v-model="formeditanggaran.model.sep"
                  @change="handleChangeValueBulan"
                  ></a-input-number>
              </a-form-model-item>
              <a-form-model-item label="Desember" prop="des">
                <a-input-number
                  :min="0"
                  class="m-width-full m-text-align-right"
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  v-model="formeditanggaran.model.des"
                  @change="handleChangeValueBulan"
                  ></a-input-number>
              </a-form-model-item>
            </a-col>
          </a-row>
      </a-form-model>
      <template slot="footer">
        <a-button
            type="primary"
            @click="onSaveEdit"
            :loading="loadingtable"
            >Save</a-button
          >
      </template>
    </a-modal>
  </div>
</template>

<script>
import _ from "lodash";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import ModalCodeBudget from "@/components/anggaran/ModalCodeBudget.vue";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import { mapGetters } from "vuex";

const EditableCell = {
  template: `
      <div class="editable-cell">
        <div :class="editable ? 'unhidecell editable-cell-input-wrapper' : 'hidecell editable-cell-input-wrapper'">
          <a-input :value="value" className="editcell" class="editcell-wrap" @change="handleChange" @pressEnter="check" /><a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
          />
        </div>
        <div :class="editable ? 'hidecell editable-cell-text-wrapper' : 'unhidecell editable-cell-text-wrapper'">

          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
          {{ formatRupiah(value).replace('Rp&nbsp;', '') || ' ' }}
          </span>
        </div>
      </div>
    `,
  props: {
    text: String,
  },
  mixins: [CurrencyFormat, GlobalMethod],
  data() {
    return {
      value: this.text,
      valuetemp: null,
      editable: false,
      form: null,
    };
  },
  beforeCreate() {},
  methods: {
    handleChange(e) {
      const value = e.target.value;
      this.valuetemp = value;
      this.$emit("editCell", this.valuetemp);
    },
    check() {
      this.editable = false;
      this.$emit("change", this.valuetemp);
    },
    edit() {
      this.editable = true;
    },
  },
};

export default {
  name: "tableCustom",
  props: {
    source: {},
    column: {},
    datatree: {},
    subdata: {
      type: Array,
      default: () => []
    },
    listTahun: {},
    allowtoEdit: Boolean,
    headerTitle : {},
    draft: {
      type: Boolean,
      default: false
    },
    manifest_id: {
      type: String,
      default: ''
    }
  },
  components: {
    EditableCell,
    ModalCodeBudget,
  },
  mixins: [CurrencyFormat],
  data() {
    return {
      data: this.source,
      kolom: [],
      visible: false,
      suggestOpsiPeruntukan: {},
      expandedKeys: [],
      autoExpandParent: true,
      defaultexpandedKeys: [],
      editTextCostCenter: "",
      editCodeCostCenter: "",
      headerTitleData: this.headerTitle,

      popoverEditCodeCostCenter: "",
      HeaderisClicked: "",
      modal: {
        visible: false,
        item: "",
        data: {},
      },
      loadingtable: false,
      loadingAdd: false,
      modaleditvalueanggaran: false,
      modaleditvalueanggarantitle: "",
      formeditanggaran: {
        model : {},
        rules : {}
      }
    };
  },
  beforeCreate() {
    this.formadd = this.$form.createForm(this);
  },
  mounted() {
    this.HeaderisClicked = "rekap:hide;";
    this.listTahun.dtl.forEach((element) => {
      this.HeaderisClicked += element + ":unhide";
    });
    this.getcolomns();
  },
  created() {
    this.kolom = this.column;
    this.kolom[1].asal_children = this.kolom[1].children;

    //hilangkan kolom rekap
    let jmlcol = this.kolom[1].children.length;
    let isitemp = this.kolom[1].children;
    this.kolom[1].children = [];
    this.kolom[1].children = isitemp.slice(0, jmlcol - 1);
    this.defaultexpandedKeys.push(this.source[0].key);
  },
  computed: {
    ...mapGetters(["getAuth"]),
    toptitle() {
      let lakhir = this.listTahun.dtl.length - 1;
      return (
        "Period " + this.listTahun.dtl[0] + " - " + this.listTahun.dtl[lakhir]
      );
    },
    longwidthTable() {
      let returns = 0;
      let iff = this.HeaderisClicked.split(";");
      if (iff[0] == "rekap:hide") {
        //kolom dihitung dari array ke 2 yaitu kolom detil
        for (let x = 1; x < iff.length; x++) {
          let temp = iff[x].split(":");
          if (temp[1] == "unhide") {
            for (let i = 0; i < this.kolom[1].children.length; i++) {
              if (
                !(this.kolom[1].children[i].className.indexOf("kolom") >= 0)
              ) {
                for (
                  let j = 0;
                  j < this.kolom[1].children[i].children.length;
                  j++
                ) {
                  returns += this.kolom[1].children[i].children[j].width
                    ? this.kolom[1].children[i].children[j].width
                    : 150;
                }
              }
            }
          } else {
            returns = parseInt(this.kolom[0].width);
          }
        }
        returns += parseInt(this.kolom[0].width);
      } else {
        for (let x = 1; x < iff.length; x++) {
          let temp = iff[x].split(":");
          if (temp[1] == "hide") {
            for (let i = 0; i < this.kolom[1].children.length; i++) {
              if (this.kolom[1].children[i].className.indexOf("kolom") >= 0) {
                for (
                  let j = 0;
                  j < this.kolom[1].children[i].children.length;
                  j++
                ) {
                  returns += this.kolom[1].children[i].children[j].width
                    ? this.kolom[1].children[i].children[j].width
                    : 150;
                }
              }
            }
          } else {
            returns = parseInt(this.kolom[0].width);
          }
        }
      }

      //console.log("long",returns);
      return returns;
    },
    lookupmenu() {
      let iff = this.HeaderisClicked.split(";");
      let menu = [];

      iff.forEach((element) => {
        let el = element.split(":");
        let ai = { key: el[0], label: el[1], root: iff[0] };
        menu.push(ai);
      });
      return menu;
    },
  },
  methods: {
    hide() {
      this.visible = !this.visible;
    },
    
    modalbuttonAdd() {
      this.loadingAdd = true
      this.formadd.validateFields( async (err, values) => {
        if(err){
          this.loadingAdd = false
          return
        }

        try {
          const payload = {
            anggaran_id: this.manifest_id,
            peruntukan_id: values.peruntukan,
            sub_peruntukan: values.subperuntukan,
            item_anggaran: values.item_anggaran
          }
          
          const response = await axios({
            method: "POST",
            url: this.$serviceUrl + "anggaran/item_add",
            data: payload,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
          this.loadingAdd = false
          this.visible = false
          this.$emit('refresh_page', true)
        } catch (error) {
          this.loadingAdd = false
          console.log(error.response);
          this.displayMessageValue("error", error);
        }
      })
    },

    handleMenuClick(e) {
      let identText = this.HeaderisClicked;
      let items = e.key.split(":");
      if (items[0] == "rekap") {
        if (items[1] == "hide") {
          identText = identText.replace("rekap:hide", "rekap:unhide");
          this.HeaderisClicked = identText.replace(
            items[0] + ":hide" + items[1],
            items[0] + ":unhide"
          );
        } else {
          identText = identText.replace("rekap:unhide", "rekap:hide");
          this.HeaderisClicked = identText.replace(":unhide", ":hide");
        }
      }

      if (items[0] !== "rekap" && items[3] == "unhide") {
        this.$notification.warning({
          message: "Warning Message!",
          description: "You can't expand when you collapse/expand all year!",
        });
      }

      if (items[0] !== "rekap" && items[3] == "hide") {
        if (items[1] == "hide") {
          this.HeaderisClicked = identText.replace(
            items[0] + ":" + items[1],
            items[0] + ":unhide"
          );
        } else {
          this.HeaderisClicked = identText.replace(
            items[0] + ":" + items[1],
            items[0] + ":hide"
          );
        }
      }

      this.getcolomns();
    },
    getcolomns() {
      let col = [];
      let iff = this.HeaderisClicked.split(";");

      //console.log("iff",iff);
      if (iff[0] == "rekap:unhide") {
        //console.log("rekap:unhide")
        let splitiff = iff[0].split(":");
        this.kolom[1].children = this.kolom[1].asal_children;
        let tempkolom = this.kolom[1];
        tempkolom.children = tempkolom.asal_children;

        //console.log("this.kolom[1]",this.kolom[1]);
        let lengtcol = this.kolom[1].children.length;
        for (let y = 0; y < lengtcol; y++) {
          if (tempkolom.children[y].className.indexOf("alltahun") >= 0) {
            if (splitiff[1] == "unhide") {
              tempkolom.children[y].className = tempkolom.children[
                y
              ].className = "unhide alltahun";
              tempkolom.children[y].children[0].className = tempkolom.children[
                y
              ].children[0].className = "unhide alltahun";
              col.push(tempkolom.children[y]);
            } else {
              tempkolom.children[y].className = tempkolom.children[
                y
              ].className = "hide alltahun";
              tempkolom.children[y].children[0].className = tempkolom.children[
                y
              ].children[0].className = "hide alltahun";
              col.push(tempkolom.children[y]);
            }
          }
          // else if(tempkolom.children[y].className.indexOf("kolom")>=0){
          //   console.log('indexOf("kolom"',splitiff[1]);
          //    if (splitiff[1]=="hide"){
          //       tempkolom.children[y].className = tempkolom.children[y].className.replace("unhide","hide");
          //       tempkolom.children[y].className = tempkolom.children[y].className.replace("hide","unhide");
          //       tempkolom.children[y].children[0].className = tempkolom.children[y].children[0].className.replace("unhide","hide");
          //       tempkolom.children[y].children[0].className = tempkolom.children[y].children[0].className.replace("hide","unhide");
          //       col.push(tempkolom.children[y]);
          //     }
          // }
          // if(tempkolom.children[y].className=="relative"){
          //   col.push(tempkolom.children[y]);
          // }
        }
        this.kolom[1].children = col;
      } else {
        let s = [];
        let tempkolom = this.kolom[1];
        s.push(...[this.kolom[1].asal_children]);
        //this.kolom[1].children = s.b[0]
        let children = s[0];

        this.kolom[1].children = children;
        //j.forEach(children => {
        // this.kolom[1].push(...children)
        //})
        //this.kolom[1].children = xdv
        //tempkolom.push(...[this.kolom[1]])
        //console.log("panjang thn",iff.length);
        for (let x = 1; x < iff.length; x++) {
          let tempthn = iff[x].split(":");

          //console.log("expand tahun",tempthn[1]);
          for (let y = 0; y < tempkolom.asal_children.length; y++) {
            if (
              tempthn[1] == "hide" &&
              tempkolom.children[y].className.indexOf(
                "th" + tempthn[0] + "rekap kolom"
              ) >= 0
            ) {
              //console.log("colek rekap kolom");
              tempkolom.children[y].className =
                "unhide header th" + tempthn[0] + "rekap kolom";
              tempkolom.children[y].children[0].className =
                "unhide header th" + tempthn[0] + "rekap kolom";
              tempkolom.children[y].children[1].className =
                "unhide header th" + tempthn[0] + "rekap kolom";
              tempkolom.children[y].children[2].className =
                "unhide header th" + tempthn[0] + "rekap kolom";
              tempkolom.children[y].children[3].className =
                "unhide header th" + tempthn[0] + "rekap kolom";
              tempkolom.children[y].children[4].className =
                "unhide header th" + tempthn[0] + "rekap kolom";
              col.push(tempkolom.children[y]);
            }

            if (
              tempthn[1] == "unhide" &&
              tempkolom.children[y].className == "unhide header th" + tempthn[0]
            ) {
              if (
                tempkolom.children[y].className.indexOf(
                  "header th" + tempthn[0]
                ) >= 0
              ) {
                tempkolom.children[y].className =
                  "unhide header th" + tempthn[0];
                tempkolom.children[y].children[0].className =
                  "unhide header th" + tempthn[0];
                col.push(tempkolom.children[y]);
              }
            }

            if (tempkolom.children[y].className == "relative") {
              col.push(tempkolom.children[y]);
            }
          }
        }
        this.kolom[1].children = col;
        tempkolom = [];
        col = [];
      }
    },
    hideunhideALL() {
      var elmntThn = document.getElementById("HeaderisClicked").value;
      this.kolom[0].showcolumn = elmntThn;
    },
    filterOptionperuntukan(input, option) {
      // return (
      //   option.componentOptions.children[0].text
      //     .toLowerCase()
      //     .indexOf(input.toLowerCase()) >= 0
      // );
    },

    handleperuntukan(val) {
      this.formadd.resetFields(["subperuntukan"]);

      let fillteredData = _.filter(
        this.subdata,
        (item) => item.peruntukan_id.indexOf(val) >= 0
      );
      this.suggestOpsiPeruntukan = fillteredData
    },

    onExpand(expandedKeys, info) {
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.expandedKeys = info.key;
      this.autoExpandParent = false;
    },
    onCellChange(key, dataIndex, value) {
      let tmpsrc = this.source;
      let splitcode = key.split(";");

      let index_1 = _.findIndex(
        this.source[0].children,
        (e) => {
          return e.key == splitcode[0];
        },
        0
      );
      //console.log(index_1);
      if (splitcode.length == 2) {
        //child 2 level
        let index_2 = _.findIndex(
          this.source[0].children[index_1].children,
          (e) => {
            return e.key == key;
          },
          0
        );
        tmpsrc[0].children[index_1].children[index_2][dataIndex] = [
          dataIndex,
          value,
        ];
        this.source = tmpsrc;
        this.popoverEditCodeCostCenter = null;
        console.log(dataIndex,value,tmpsrc[0].children[index_1].children[index_2][dataIndex]);
      }
      if (splitcode.length == 3) {
        //child 3 level
        let params = splitcode[0] + ";" + splitcode[1];
        let index_2 = _.findIndex(
          this.source[0].children[index_1].children,
          (e) => {
            return e.key == params;
          },
          0
        );
        
        let index_3 = _.findIndex(
          this.source[0].children[index_1].children[index_2].children,
          (e) => {
            return e.key == key;
          },
          0
        );

        //update value sesuai entrian
        tmpsrc[0].children[index_1].children[index_2].children[index_3][
          dataIndex
        ] = [dataIndex, value];

        //update value rekap 
        let thn = dataIndex.substring(3,7);
        let ttl = 0;
        for (let i = 1; i <= 12; i++) {
          ttl = ttl+Number(tmpsrc[0].children[index_1].children[index_2].children[index_3]['bln'+thn+i.toString()][1]);
        }

        //this.source = tmpsrc;
        this.popoverEditCodeCostCenter = null;
        this.updateDataRow(thn,tmpsrc[0].children[index_1].children[index_2].children[index_3],ttl);
      }
    },
    showPopOverEditCostcenter(name) {
      //console.log(name);
      // this.editTextCostCenter = name.nameitem;
      // this.editCodeCostCenter = name.key;
      // this.popoverEditCodeCostCenter = name.key;
      let thn = this.headerTitleData[0].tahun_anggaran;
      this.loadingtable = true;
      axios({
          method: "get",
          url: this.$serviceUrl + "anggaran/dtl_anggaran",
          params: {
            kode_anggaran: name['kode_anggran'+thn],
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.modaleditvalueanggarantitle = "Editing Value " + name.nameitem;
            this.modaleditvalueanggaran = true;
            
            this.formeditanggaran.model = {
              name: name.nameitem,
              kode_anggaran: name['kode_anggran'+thn],
              anggaran_dtl_id: name['anggaran_dtl_id'+thn],
              unit: Number(name['jumlah'+thn])==0 ? 1: Number(name['jumlah'+thn]),
              unit_price: name['harga_satuan'+thn],
              jan: name['bln'+thn+'1'][1],
              feb: name['bln'+thn+'2'][1],
              mar: name['bln'+thn+'3'][1],
              apr: name['bln'+thn+'4'][1],
              mei: name['bln'+thn+'5'][1],
              jun: name['bln'+thn+'6'][1],
              jul: name['bln'+thn+'7'][1],
              aug: name['bln'+thn+'8'][1],
              sep: name['bln'+thn+'9'][1],
              okt: name['bln'+thn+'10'][1],
              nov: name['bln'+thn+'11'][1],
              des: name['bln'+thn+'12'][1],
              realization: response.data.total_realisasi,
              total_price: Number(name['jumlah'+thn])*Number(name['harga_satuan'+thn]),
            }
            this.loadingtable = false;
          })
          .catch((err) => {
            this.loadingtable = false;
            let response = Object.assign({}, err.response.data);
            console.log(response);
            if (response.message && response.status==false){
              this.$notification.warning({
                message: "Warning Message!",
                description: response.message,
              });
            }
          });
    },
    simpanEditCostcenter() {
      //console.log(this.editTextCostCenter, this.editCodeCostCenter);
      let tmpsrc = this.source;
      let splitcode = this.editCodeCostCenter.split(";");

      let index_1 = _.findIndex(
        this.source[0].children,
        (e) => {
          return e.key == splitcode[0];
        },
        0
      );
      if (splitcode.length == 2) {
        //child 2 level
        let index_2 = _.findIndex(
          this.source[0].children[index_1].children,
          (e) => {
            return e.key == this.editCodeCostCenter;
          },
          0
        );
        tmpsrc[0].children[index_1].children[
          index_2
        ].nameitem = this.editTextCostCenter;
        this.source = tmpsrc;
        this.popoverEditCodeCostCenter = null;
      }
      if (splitcode.length == 3) {
        //child 3 level
        let params = splitcode[0] + ";" + splitcode[1];
        let index_2 = _.findIndex(
          this.source[0].children[index_1].children,
          (e) => {
            return e.key == params;
          },
          0
        );
        let index_3 = _.findIndex(
          this.source[0].children[index_1].children[index_2].children,
          (e) => {
            return e.key == this.editCodeCostCenter;
          },
          0
        );
        tmpsrc[0].children[index_1].children[index_2].children[
          index_3
        ].nameitem = this.editTextCostCenter;
        this.source = tmpsrc;
        this.popoverEditCodeCostCenter = null;
      }
    },
    closePopOver() {
      this.popoverEditCodeCostCenter = null;
    },
    handleChangeFilter() {
      this.getcolomns();
    },
    handleModal(item) {
      if (this.modal.visible) {
        this.modal.visible = false;
      } else {
        axios({
          method: "get",
          url: this.$serviceUrl + "anggaran/dtl_anggaran",
          params: {
            kode_anggaran: item,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.modal.item = item;
            this.modal.data = response.data;
            this.modal.visible = true;
          })
          .catch((err) => {
            let response = Object.assign({}, err.response.data);
            console.log(response);
            if (response.message && response.status==false){
              this.$notification.warning({
                message: "Warning Message!",
                description: response.message,
              });
            }
          });
      }
    },
    updateDataRow(thn,item,ttl){
      this.loadingtable = true;
      axios({
        method: "post",
        url: this.$serviceUrl + "anggaran/edit_detil_anggaran",
        data: {
          tlc:this.getAuth.username,
          name: item['nameitem'],
          kode_anggaran: item['kode_anggran'+thn],
          unit:item['jumlah'+thn],
          unit_price:item['harga_satuan'+thn],
          bln1:item['bln'+thn+'1'][1],
          bln2:item['bln'+thn+'2'][1],
          bln3:item['bln'+thn+'3'][1],
          bln4:item['bln'+thn+'4'][1],
          bln5:item['bln'+thn+'5'][1],
          bln6:item['bln'+thn+'6'][1],
          bln7:item['bln'+thn+'7'][1],
          bln8:item['bln'+thn+'8'][1],
          bln9:item['bln'+thn+'9'][1],
          bln10:item['bln'+thn+'10'][1],
          bln11:item['bln'+thn+'11'][1],
          bln12:item['bln'+thn+'12'][1],
          sub_total:ttl,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then((response) => {
        if (response.data.status){
          this.$notification.success({
              message: "Success Message!",
              description: response.data.message,
            });
          Event.$emit("reloadTabelAnggaran", true);
        }else{
          this.$notification.error({
              message: "Error Message!",
              description: response.data.message,
            });
        }
        this.loadingtable = false;
      })
      .catch((err) => {
        this.loadingtable = false;
        let response = Object.assign({}, err.response.data);
        console.log(response);
        if (response.message && response.status==false){
          this.$notification.warning({
            message: "Warning Message!",
            description: response.message,
          });
        }
      });
    },

    async onSaveEdit(){
      this.loadingtable = true;
      
      try {
        const payload = {
          anggaran_id: this.manifest_id,
          tlc:this.getAuth.username,
          name: this.formeditanggaran.model.name,
          kode_anggaran: this.formeditanggaran.model.kode_anggaran,
          anggaran_dtl_id: this.formeditanggaran.model.anggaran_dtl_id,
          unit:this.formeditanggaran.model.unit ? this.formeditanggaran.model.unit : 0,
          unit_price:this.formeditanggaran.model.unit_price ? this.formeditanggaran.model.unit_price : 0,
          bln1:this.formeditanggaran.model.jan ? this.formeditanggaran.model.jan : 0,
          bln2:this.formeditanggaran.model.feb ? this.formeditanggaran.model.feb : 0,
          bln3:this.formeditanggaran.model.mar ? this.formeditanggaran.model.mar : 0,
          bln4:this.formeditanggaran.model.apr ? this.formeditanggaran.model.apr : 0,
          bln5:this.formeditanggaran.model.mei ? this.formeditanggaran.model.mei : 0,
          bln6:this.formeditanggaran.model.jun ? this.formeditanggaran.model.jun : 0,
          bln7:this.formeditanggaran.model.jul ? this.formeditanggaran.model.jul : 0,
          bln8:this.formeditanggaran.model.aug ? this.formeditanggaran.model.aug :0 ,
          bln9:this.formeditanggaran.model.sep ? this.formeditanggaran.model.sep :0,
          bln10:this.formeditanggaran.model.okt ? this.formeditanggaran.model.okt :0,
          bln11:this.formeditanggaran.model.nov ? this.formeditanggaran.model.nov : 0,
          bln12:this.formeditanggaran.model.des ? this.formeditanggaran.model.des :0,
        }

        const response = await axios({
          method: "post",
          url: this.$serviceUrl + "anggaran/item_edit",
          data: payload,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })

        this.loadingtable = false;
        this.modaleditvalueanggaran = false
        if(response){
          this.$emit('refresh_page', true)
        }
      } catch (error) {
        this.loadingtable = false;
      }
    },

    saveformeditanggaran(){
      this.loadingtable = true;
      axios({
        method: "post",
        url: this.$serviceUrl + "anggaran/edit_detil_anggaran",
        data: {
          tlc:this.getAuth.username,
          name: this.formeditanggaran.model.name,
          kode_anggaran: this.formeditanggaran.model.kode_anggaran,
          unit:this.formeditanggaran.model.unit ?
            this.formeditanggaran.model.unit : 0,
          unit_price:this.formeditanggaran.model.unit_price
            ? this.formeditanggaran.model.unit_price : 0,
          bln1:this.formeditanggaran.model.jan ?
            this.formeditanggaran.model.jan : 0,
          bln2:this.formeditanggaran.model.feb
            ? this.formeditanggaran.model.feb : 0,
          bln3:this.formeditanggaran.model.mar ?
            this.formeditanggaran.model.mar : 0,
          bln4:this.formeditanggaran.model.apr ?
            this.formeditanggaran.model.apr : 0,
          bln5:this.formeditanggaran.model.mei ?
            this.formeditanggaran.model.mei : 0,
          bln6:this.formeditanggaran.model.jun ?
            this.formeditanggaran.model.jun : 0,
          bln7:this.formeditanggaran.model.jul ?
            this.formeditanggaran.model.jul : 0,
          bln8:this.formeditanggaran.model.aug ?
            this.formeditanggaran.model.aug :0 ,
          bln9:this.formeditanggaran.model.sep ?
            this.formeditanggaran.model.sep :0,
          bln10:this.formeditanggaran.model.okt ?
            this.formeditanggaran.model.okt :0,
          bln11:this.formeditanggaran.model.nov ?
            this.formeditanggaran.model.nov : 0,
          bln12:this.formeditanggaran.model.des ?
            this.formeditanggaran.model.des :0,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then((response) => {
        if (response.data.status){
          this.$notification.success({
              message: "Success Message!",
              description: response.data.message,
            });
          Event.$emit("reloadTabelAnggaran", true);
        }else{
          this.$notification.error({
              message: "Error Message!",
              description: response.data.message,
            });
        }
        this.loadingtable = false;
        this.$router.go();
      })
      .catch((err) => {
        this.loadingtable = false;
        let response = Object.assign({}, err.response.data);
        console.log(response);
        if (response.message && response.status==false){
          this.$notification.warning({
            message: "Warning Message!",
            description: response.message,
          });
        }
      });
    },
    handlechangetototalprice(){
      this.formeditanggaran.model.total_price = 
        Number(this.formeditanggaran.model.unit)*Number(this.formeditanggaran.model.unit_price)

      let valueperbulan = this.formeditanggaran.model.total_price/12
      this.formeditanggaran.model.jan = valueperbulan
      this.formeditanggaran.model.feb = valueperbulan
      this.formeditanggaran.model.mar = valueperbulan
      this.formeditanggaran.model.apr = valueperbulan
      this.formeditanggaran.model.mei = valueperbulan
      this.formeditanggaran.model.jun = valueperbulan
      this.formeditanggaran.model.jul = valueperbulan
      this.formeditanggaran.model.aug = valueperbulan
      this.formeditanggaran.model.sep = valueperbulan
      this.formeditanggaran.model.okt = valueperbulan
      this.formeditanggaran.model.nov = valueperbulan
      this.formeditanggaran.model.des = valueperbulan
    },
    handleChangeValueBulan(){
      let sum = 
        Number(this.formeditanggaran.model.jan ? this.formeditanggaran.model.jan : 0)+
        Number(this.formeditanggaran.model.feb ? this.formeditanggaran.model.feb : 0)+
        Number(this.formeditanggaran.model.mar ? this.formeditanggaran.model.mar : 0)+
        Number(this.formeditanggaran.model.apr ? this.formeditanggaran.model.apr : 0)+
        Number(this.formeditanggaran.model.mei ? this.formeditanggaran.model.mei : 0)+
        Number(this.formeditanggaran.model.jun ? this.formeditanggaran.model.jun : 0)+
        Number(this.formeditanggaran.model.jul ? this.formeditanggaran.model.jul : 0)+
        Number(this.formeditanggaran.model.aug ? this.formeditanggaran.model.aug : 0)+
        Number(this.formeditanggaran.model.sep ? this.formeditanggaran.model.sep : 0)+
        Number(this.formeditanggaran.model.okt ? this.formeditanggaran.model.okt : 0)+
        Number(this.formeditanggaran.model.nov ? this.formeditanggaran.model.nov : 0)+
        Number(this.formeditanggaran.model.des ? this.formeditanggaran.model.des : 0);

      this.formeditanggaran.model.total_price = sum
      console.log(this.formeditanggaran.model.total_price,this.formeditanggaran.model.unit)
      this.formeditanggaran.model.unit_price = this.formeditanggaran.model.total_price/this.formeditanggaran.model.unit
    }
  },
};
</script>

<style>
.hide,
.hidecell {
  display: none;
}
/* .ant-table-row-level-0{background-color: rgba(26, 188, 156, 0.3);}
.ant-table-row-level-1{background-color: rgba(26, 188, 156, 0.2);}
.ant-table-row-level-2{background-color: rgba(26, 188, 156, 0.1);}
.ant-table-row-level-3{background-color: rgba(26, 188, 156, 0.05);} */

.ant-table-thead {
  background-color: rgba(245, 245, 245, 1);
}

.editable-cell {
  position: relative;
}

.editable-cell-input-wrapper {
  padding-right: 24px;
}

/* .editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
} */

.editable-cell-icon,
.editable-cell-icon-check {
  position: relative;
  right: 0;
  width: 20px;
  cursor: pointer;
}

.editable-cell-icon {
  line-height: 18px;
  display: none;
  float: left;
}

.editable-cell-icon-check {
  line-height: 28px;
  position: absolute;
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: #108ee9;
}

.editable-add-btn {
  margin-bottom: 8px;
}

input[className="editcell"] {
  height: auto;
  padding: 0px 5px;
}

.editcell-wrap {
  text-align: right;
}
</style>
